import { useState } from 'react';

import banner from '../../../../../assets/image/infopanel_fixed_banner.png';
import ModalConfirmation from '../../../../../components/ModalConfirmation';
import { INFOPANEL_CTA_LINK } from '../../../../../utils/constants';
import { trackEvent } from '../../../../../utils/MatomoConfig';
import { sendLead } from '../utils';

const FixedBanner = ({ usuario }) => {
  const [showCTA, setShowCTA] = useState(false);

  const handleShowCTA = () => {
    setShowCTA(!showCTA);
  };

  const confirmCTA = () => {
    setShowCTA(false);
    sendLead(usuario, 'upsell_infopanel');

    trackEvent('Upsell/Crossell', 'upsell-banner-pesquisa');
    window.open(INFOPANEL_CTA_LINK);
  };

  return (
    <>
      <div className="fixed-banner-component">
        <div id="infopanel-result-fixed-banner" onClick={handleShowCTA} role="link" className="banner-area">
          <img src={banner} alt="Banner" />
        </div>
      </div>

      <ModalConfirmation
        title="Informações para alteração do plano"
        message="Caso deseje saber mais informações para evoluir o seu plano, clique em “Confirmar”"
        show={showCTA}
        btnConfirmClass="upsell"
        buttonConfirm="Confirmar"
        buttonCancel="Cancelar"
        onConfirm={confirmCTA}
        onCancel={handleShowCTA}
      />
    </>
  );
};

export default FixedBanner;
